import React from 'react';
import { Box, Typography, Button, Card, CardContent, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';

// Mock clubs
const clubs = [
    { id: 101, nom: 'Alianza Lima', sport: 'Football' },
    { id: 102, nom: 'Lima Basketball Club', sport: 'Basketball' },
];

// Mock événements
const events = [
    {
        id: 1,
        title: 'Football Match - Liga 1',
        date: 'December 15, 2024',
        clubId: 101,
        sport: 'Football',
        icon: <SportsSoccerIcon />,
        image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400&h=250&fit=crop',
    },
    {
        id: 2,
        title: 'Basketball Championship',
        date: 'December 20, 2024',
        clubId: 102,
        sport: 'Basketball',
        icon: <SportsBasketballIcon />,
        image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&h=250&fit=crop',
    },
];

const getSportColor = (sport) => {
    const colors = {
        'Football': '#FF6B6B',
        'Basketball': '#FF6B35',
    };
    return colors[sport] || '#666';
};

const AdminEvents = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ p: 4, position: 'relative' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4 }}>
                <Typography variant="h4" fontWeight={700} gutterBottom>
                    Event Management
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{
                        fontWeight: 700,
                        borderRadius: 3,
                        px: 4,
                        py: 1.5,
                        fontSize: '1.1rem',
                        background: 'linear-gradient(135deg, #FF6B6B 0%, #E53E3E 100%)',
                        color: 'white',
                        boxShadow: '0 4px 16px rgba(255,107,107,0.10)',
                        textTransform: 'none',
                        transition: 'all 0.3s',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #E53E3E 0%, #FF6B6B 100%)',
                            boxShadow: '0 8px 24px rgba(255,107,107,0.18)',
                        },
                    }}
                    onClick={() => navigate('/admin-panel/events/new')}
                >
                    Add event
                </Button>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {events.map(ev => {
                    const club = clubs.find(c => c.id === ev.clubId);
                    return (
                        <Card key={ev.id} sx={{ background: 'white', borderRadius: 4, boxShadow: '0 4px 24px rgba(255,107,107,0.10)', p: 0, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, overflow: 'hidden', minHeight: { xs: 180, md: 200 }, height: { md: 200 }, alignItems: 'stretch' }}>
                            {/* Contenu à gauche */}
                            <Box sx={{ flex: 1, p: 3, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', minHeight: { xs: 120, md: 200 } }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                    <Typography variant="h6" fontWeight={700} sx={{ mb: 0 }}>{ev.title}</Typography>
                                    <Chip
                                        label={ev.sport}
                                        sx={{
                                            background: getSportColor(ev.sport),
                                            color: 'white',
                                            fontWeight: 700,
                                            fontSize: 14,
                                            borderRadius: 999,
                                            px: 2,
                                            height: 28,
                                            ml: 1
                                        }}
                                    />
                                </Box>
                                <Typography color="text.secondary" sx={{ mb: 1 }}>{ev.date}</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    Associated club: <span style={{ color: '#FF6B6B' }}>{club ? club.nom : 'Unknown'}</span> ({club ? club.sport : ''})
                                </Typography>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    sx={{ mt: 2, borderRadius: 2, fontWeight: 700, textTransform: 'none', px: 2, py: 0.5, minWidth: 0, alignSelf: 'flex-start', fontSize: 15 }}
                                    onClick={() => navigate(`/admin-panel/events/${ev.id}/edit`)}
                                >
                                    Edit
                                </Button>
                            </Box>
                            {/* Image à droite, responsive */}
                            <Box sx={{ width: { xs: '100%', md: 300 }, height: { xs: 180, md: '100%' }, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end', p: 0, m: 0 }}>
                                <Box component="img" src={ev.image} alt={ev.sport} sx={{ width: '100%', height: '100%', objectFit: 'cover', borderTopRightRadius: { xs: 0, md: 16 }, borderBottomRightRadius: { xs: 0, md: 16 }, borderBottomLeftRadius: { xs: 16, md: 0 }, borderTopLeftRadius: { xs: 16, md: 0 }, display: 'block', transition: 'border-radius 0.2s' }} />
                            </Box>
                        </Card>
                    );
                })}
            </Box>
        </Box>
    );
};

export default AdminEvents; 